import { render } from "./Index.vue?vue&type=template&id=4cc9bea2"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Home/Hero/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4cc9bea2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cc9bea2', __exports__)) {
    api.reload('4cc9bea2', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=4cc9bea2", () => {
    api.rerender('4cc9bea2', render)
  })

}


export default __exports__